module.exports = __webpack_public_path__ + "static/media/APP_OfficeChamp_152x174_4.2148af13.png";